/**
 * input动态聚焦时使用
 * v-focus
 */

export default {
    // 当被绑定的元素插入到 DOM 中时执行
    inserted: function (el) {
        // 聚焦元素
        if (el) {
            el.querySelector('input')?.focus();
        }
    }
};